import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { SoundService } from 'src/app/shared/service/sound.service';
import { Menu, NavService } from '../../../service/nav.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnChanges {

  public theme: string;
  atmosphere: boolean = false;

  @Input()
  currentPage: string;

  public menuItems: Menu[];
  public openSide: boolean = false;
  public activeItem: string = 'home';
  public active: boolean = false;
  public activeChildItem: string = ''
  public overlay: boolean = false;

  constructor(public navServices: NavService, private sound: SoundService) { }

  ngOnInit() {
    this.sound.getTheme().subscribe((value) => {
      this.theme = value;
    })
  }

  ngOnChanges() {
    this.currentPage = this.currentPage.toLowerCase();

    switch (this.currentPage) {
      case ("all"): {
        this.menuItems = this.navServices.MENUITEMSALL;
        break;
      }
      case ("main"): {
        this.menuItems = this.navServices.MENUITEMSMAIN;
        break;
      }
      case ("services"): {
        this.menuItems = this.navServices.MENUITEMSSERVICES;
        break;
      }
      case ("about"): {
        this.menuItems = this.navServices.MENUITEMSABOUT;
        break;
      }
      case ("contact"): {
        this.menuItems = this.navServices.MENUITEMSCONTACT;
        break;
      }
      case ("blog"): {
        this.menuItems = this.navServices.MENUITEMSBLOG;
        break;
      }
      case ("faq"): {
        this.menuItems = this.navServices.MENUITEMSFAQ;
        break;
      }
      case ("policy"): {
        this.menuItems = this.navServices.MENUITEMSPOLICY;
        break;
      }
    }

    this.atmosphere = false;
  }

  // ngAfterViewChecked() {
  //   if (this.theme == 'dark') {
  //     if (this.atmosphere == false) {
  //       let team = document.querySelectorAll("[menu-sound='true']").length > 0;
  //       if (team) {
  //         this.atmosphere = true;
  //         this.sound.turnOnmenu-sound();
  //       }
  //     }
  //   } else {
  //     this.atmosphere = false;
  //   }
  // }

  toggleSidebar() {
    this.openSide = !this.openSide
  }

  closeOverlay() {
    this.openSide = false
  }

  //For Active Main menu in Mobile View
  setActive(menuItem) {
    if (this.activeItem === menuItem) {
      this.activeItem = ''
    } else {
      this.activeItem = menuItem
    }
  }

  isActive(item) {
    return this.activeItem === item
  }

  // For Active Child Menu in Mobile View
  setChildActive(subMenu) {
    if (this.activeChildItem === subMenu) {
      this.activeChildItem = ''
    } else {
      this.activeChildItem = subMenu
    }
  }

  ischildActive(subMenu) {
    return this.activeChildItem === subMenu
  }
}
